/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandSpeedtest = createReactComponent("outline", "brand-speedtest", "IconBrandSpeedtest", [["path", { "d": "M5.636 19.364a9 9 0 1 1 12.728 0", "key": "svg-0" }], ["path", { "d": "M16 9l-4 4", "key": "svg-1" }]]);

export { IconBrandSpeedtest as default };
//# sourceMappingURL=IconBrandSpeedtest.mjs.map
